import { render, staticRenderFns } from "./forex-book.vue?vue&type=template&id=55db5783&scoped=true"
import script from "./forex-book.vue?vue&type=script&lang=js"
export * from "./forex-book.vue?vue&type=script&lang=js"
import style0 from "./forex-book.vue?vue&type=style&index=0&id=55db5783&prod&lang=css"
import style1 from "./forex-book.vue?vue&type=style&index=1&id=55db5783&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55db5783",
  null
  
)

export default component.exports